// Co-Authored-By: AI-Assisted | updated: 2026-10-29 00:00:00
type AppEnv = 'development' | 'stg' | 'production';
interface PathConfig {
  ROOT_PATH: string;
  DOMAIN: string;
  WEBSOCKET: string;
  BUCKET: string;
  APPID: string;
  SIGN_KEY: string;
}

const ENV_INDEX: 0 | 1 | 2 | undefined = undefined;

const ENV_MAP: Record<0 | 1 | 2, AppEnv> = {
  0: 'development',
  1: 'stg',
  2: 'production',
};

export const REACT_APP_ENV: AppEnv = ENV_INDEX !== undefined ? ENV_MAP[ENV_INDEX] : (process.env.REACT_APP_ENV as AppEnv) ?? 'development';

const path_config: Record<AppEnv, PathConfig> = {
  development: {
    ROOT_PATH: 'https://api-ipp-dev.cpgroupcloud.com',
    DOMAIN: 'https://gsp-dev.cpgroupcloud.com/',
    WEBSOCKET: 'wss://api-ipp-dev.cpgroupcloud.com/websocket',
    BUCKET: 'cp-cpmart-dev',
    APPID: 'gsp_c7634043bf',
    SIGN_KEY: 'f8cff967b175644d92c92ca80dee389e',
  },
  stg: {
    ROOT_PATH: 'https://api-ipp-stg.cpgroupcloud.com',
    DOMAIN: 'https://gsp-dev.cpgroupcloud.com/',
    WEBSOCKET: 'wss://api-ipp-dev.cpgroupcloud.com/websocket',
    BUCKET: 'cp-cpmart-dev',
    APPID: 'gsp_c7634043bf',
    SIGN_KEY: 'f8cff967b175644d92c92ca80dee389e',
  },
  production: {
    ROOT_PATH: 'https://api-ipp-i.cpgroupcloud.com',
    DOMAIN: 'https://gsp-i.cpgroupcloud.com/',
    WEBSOCKET: 'wss://api-ipp-i.cpgroupcloud.com/websocket',
    BUCKET: 'cp-cpmart',
    APPID: 'gsp_4b7e2a9d10',
    SIGN_KEY: '2d8f6a1c4e9b7d305f8a2c6e1b9d4f7a',
  },
};

const currentConfig = path_config[REACT_APP_ENV] ?? path_config.development;

export const DOMAIN = currentConfig.DOMAIN;
export const ROOT_PATH = currentConfig.ROOT_PATH;
export const WEBSOCKET = currentConfig.WEBSOCKET;
export const BUCKET = currentConfig.BUCKET;
export const APPID = currentConfig.APPID;
export const SIGN_KEY = currentConfig.SIGN_KEY;